import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface ListProcessorConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const ListProcessorConfig: React.FC<ListProcessorConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="Lista feldolgozás">
        <ConfigField
          label="Művelet típusa"
          description="Mit csináljon a listával"
        >
          <select
            value={node.data.config?.operation || 'map'}
            onChange={(e) => updateConfig('operation', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="map">Átalakítás (map)</option>
            <option value="filter">Szűrés (filter)</option>
            <option value="reduce">Összesítés (reduce)</option>
            <option value="find">Keresés (find)</option>
            <option value="slice">Részlet (slice)</option>
            <option value="concat">Összefűzés (concat)</option>
            <option value="unique">Egyedi értékek</option>
            <option value="flatten">Lapítás (flatten)</option>
          </select>
        </ConfigField>

        {node.data.config?.operation === 'map' && (
          <ConfigField
            label="Átalakítási kifejezés"
            description="Hogyan alakítsa át az elemeket"
          >
            <input
              type="text"
              value={node.data.config?.expression || ''}
              onChange={(e) => updateConfig('expression', e.target.value)}
              placeholder="item.name vagy item * 2"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
            />
          </ConfigField>
        )}

        {node.data.config?.operation === 'slice' && (
          <div className="grid grid-cols-2 gap-3">
            <ConfigField label="Kezdő index">
              <input
                type="number"
                value={node.data.config?.start || 0}
                onChange={(e) => updateConfig('start', parseInt(e.target.value))}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
              />
            </ConfigField>
            <ConfigField label="Vég index">
              <input
                type="number"
                value={node.data.config?.end || 10}
                onChange={(e) => updateConfig('end', parseInt(e.target.value))}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
              />
            </ConfigField>
          </div>
        )}

        {node.data.config?.operation === 'concat' && (
          <ConfigField
            label="Második lista"
            description="Összefűzendő lista változó"
          >
            <input
              type="text"
              value={node.data.config?.secondList || ''}
              onChange={(e) => updateConfig('secondList', e.target.value)}
              placeholder="{{other_list}}"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
            />
          </ConfigField>
        )}
      </ConfigSection>

      <div className="bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-md p-3">
        <div className="text-xs text-indigo-700 dark:text-indigo-300">
          <strong>📋 Lista műveletek:</strong>
          <br />• <strong>map:</strong> Minden elem átalakítása
          <br />• <strong>filter:</strong> Elemek szűrése
          <br />• <strong>reduce:</strong> Összesítés egyetlen értékké
          <br />• <strong>slice:</strong> Részlista kivágása
          <br />• Eredmény: <code>{'{{result}}'}</code>
        </div>
      </div>
    </div>
  );
};

export default ListProcessorConfig;
